import React from "react";
import Footer from "../../common/Footer.js";
import AnalystSideNav from "../../common/AnalystSideNav.js";
import AdminSideNav from "../../common/AdminSideNav.js";
import UnauthorisedPage from "../Unauthorised";
import TopNav from "../../common/TopNav.js";
import readXlsxFile from "read-excel-file";
import Select from "react-select";
import VirtualTable from "../../common/VirtualTable.js";
import EditableCell from "../../common/EditableCell.js";
import requireAuth from "../../hoc/requireAuth";
import authorizeAnalystOrAdmin from "../../hoc/authorizeAnalystOrAdmin";
import "sweetalert/dist/sweetalert.css";
import { connect } from "react-redux";
import {
  fetchInfrigementAllStatus,
  fetchInfrigementEcommerceStatus,
  statusSelectOptions,
  resolveReasonCode,
} from "./../../infrigementStatusCode";
import { withAlert } from "react-alert";
import { toCapitalCase } from "../../common/utils.js";
import {
  reasonCodeBasedOnPriority,
  reasonCodeToKeyPriority,
} from "../../common/priorityStatus.js";
import "../../bulkData.css";
import "../../assets/css/data-upload.css";

import { customColumnKeys, customColumnLabel, documentsColumnOf, documentsColumns, isCustomColumnKey, nestCustomColumns } from "../../customColumns";
import { planSheetDocuments, rankSheets, uploadSheetDocuments } from "../../sheetDocuments";
import Swal from "sweetalert2";
import "sweetalert2/src/sweetalert2.scss";
import DocumentsCell from "../../components/DocumentsCell";

const FormData = require("form-data");
// Header label per column key (falls back to the key itself).
const COLUMN_LABELS = {
  sn: "SN.",
  image: "IMAGE",
  url: "URL",
  domain: "DOMAIN",
  tld: "TLD",
  dateAdded: "DATE ADDED",
  priority: "PRIORITY",
  status: "STATUS",
  advertiser: "ADVERTISER",
  reason: "REASON",
  reasonCode: "REASON CODE",
  registrar: "REGISTRAR",
  ipAddress: "IP ADDRESS",
  hosting: "HOSTING",
  lastMofifiedDate: "LAST MODIFICATION DATE",
  expiryDate: "EXPIRY DATE",
  registrationDate: "REGISTRATION DATE",
  note: "NOTE",
  name: "NAME",
  org: "ORG",
  address: "ADDRESS",
  state: "STATE",
  country: "COUNTRY",
  emailAddress: "EMAIL ADDRESS",
  contactNumber: "CONTACT NUMBER",
  brand: "BRAND",
  rid: "RID",
  platform: "PLATFORM",
  heading: "HEADING",
  link: "LINK",
  site: "SITE",
  title: "TITLE",
  price: "PRICE",
  comparativeLink: "COMPARATIVE LINK",
  comparativePrice: "COMPARATIVE PRICE",
  username: "USERNAME",
  productBrand: "PRODUCT BRAND",
  categories: "CATEGORIES",
  storeId: "STORE ID",
  city: "CITY",
  Rating: "RATING",
  numberOfRatings: "NUMBER OF RATINGS",
  numberOfReviews: "NUMBER OF REVIEWS",
  mrp: "MRP",
  sellerRating: "SELLER RATING",
  pid: "PID",
  lid: "LID",
  discountPercentage: "DISCOUNT PERCENTAGE",
  flipkartAssured: "FLIPKART ASSURED",
  heroImage: "HERO IMAGE",
  supportingImage: "SUPPORTING IMAGE",
  imageCount: "IMAGE COUNT",
  imagePixelsCount: "IMAGE PIXELS COUNT",
  imageDpi: "IMAGE DPI",
  imageWhiteSpacePercentage: "IMAGE WHITE SPACE %",
  sellerExperience: "SELLER EXPERIENCE",
  sellerProductsSold: "SELLER PRODUCTS SOLD",
  sellerQualityScore: "SELLER QUALITY SCORE",
  sellerSpeedScore: "SELLER SPEED SCORE",
  productQualityRating: "PRODUCT QUALITY RATING",
  serviceQualityRating: "SERVICE QUALITY RATING",
  sku: "SKU",
  appName: "APP NAME",
  appStore: "APP STORE",
  developerName: "DEVELOPER NAME",
  latestPublishDate: "LATEST PUBLISH DATE",
  numberOfDownload: "NUMBER OF DOWNLOADS",
  version: "VERSION",
};

// Widths for non-default columns; everything else falls back to 160.
const COLUMN_WIDTHS = {
  sn: 80,
  image: 200,
  heroImage: 200,
  supportingImage: 220,
  reason: 220,
  note: 220,
  title: 240,
  url: 240,
  link: 240,
  comparativeLink: 240,
};

class DataUpload extends React.Component {
  constructor(props) {
    super(props);

    this.saveData = this.saveData.bind(this);
    this.saveUniqueData = this.saveUniqueData.bind(this);

    this.state = {
      authorised: true,
      platform: "",
      showDataSavedAlert: false,
      selectedOption: null,
      showFilesUploadedAlert: false,
      uploadedFiles: {},
      excelData: [],
      modifiedExcelData: [],
      companies: [],
      brands: [],
      reportingDate: "",
      company: "",
      brand: "",
      files: [],
      dataSaveError: {},
      filesUploading: false,
      urlDuplicates: 0,
      lidDuplicates: 0,
      imageCount: 0,
      invalidDomainCount: 0,
      statusCount: 0,
      whiteLabelUrlCount: 0,
      whiteLabelDuplicates: {},
      urlDuplicatesErrors: {},
      lidDuplicatesErrors: {},
      imageDuplicatesErrors: {},
      brandDuplicatesErrors: {},
      statusDuplicatesErrors: {},
      domainKeys: [
        "sn",
        "image",
        "domain",
        "tld",
        "priority",
        "status",
        "advertiser",
        "reason",
        "reasonCode",
        "registrar",
        "ipAddress",
        "hosting",
        "lastMofifiedDate",
        "expiryDate",
        "registrationDate",
        "note",
        "name",
        "org",
        "address",
        "state",
        "country",
        "emailAddress",
        "contactNumber",
        "brand",
        "rid",
      ],
      websiteKeys: [
        "sn",
        "image",
        "url",
        "domain",
        "dateAdded",
        "priority",
        "status",
        "advertiser",
        "registrar",
        "ipAddress",
        "hosting",
        "reason",
        "reasonCode",
        "brand",
        "rid",
      ],
      socialMediaKeys: [
        "sn",
        "image",
        "platform",
        "heading",
        "link",
        "dateAdded",
        "priority",
        "status",
        "advertiser",
        "reason",
        "reasonCode",
        "PostDate",
        "LikesCount",
        "CommentsCount",
        "SharedCount",
        "PostDuration_yt",
        "Follower/SubscriberCount",
        "FollowingCount",
        "LastPostDate",
        "LastPostComments",
        "LastPostLikes",
        "LastPostShare",
        "LastPostCount",
        "Creation/JoiningDate",
        "PostCount/YouTube_VideoCount",
        "ViewCount",
        "Telegram_LinkCount",
        "brand",
        "rid",
      ],
      ecommerceKeys: [
        "sn",
        "image",
        "site",
        "dateAdded",
        "url",
        "title",
        "price",
        "reason",
        "reasonCode",
        "comparativeLink", //add the Key for Comparative Link
        "comparativePrice", //add the Key for Comparative Price
        "priority",
        "status",
        "username",
        "productBrand",
        "categories",
        "storeId",
        "address",
        "city",
        "country",
        "Rating",
        "numberOfRatings",
        "numberOfReviews",
        "mrp",
        "sellerRating",
        "contactNumber",
        "pid",
        "lid",
        "discountPercentage",
        "flipkartAssured",
        "heroImage",
        "supportingImage",
        "imageCount",
        "imagePixelsCount",
        "imageDpi",
        "imageWhiteSpacePercentage",
        "sellerExperience",
        "sellerProductsSold",
        "sellerQualityScore",
        "sellerSpeedScore",
        "productQualityRating",
        "serviceQualityRating",
        "brand",
        "sku",
        "rid",
      ],
      appStoreKeys: [
        "sn",
        "image",
        "appName",
        "appStore",
        "dateAdded",
        "url",
        "developerName",
        "latestPublishDate",
        "numberOfDownload",
        "version",
        "status",
        "reason",
        "reasonCode",
        "priority",
        "price",
        "brand",
        "rid",
      ],
      selectedKey: "",
      duplicateLidCheck: true,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.company !== this.state.company) {
      this.getBrands();
    }

    if (
      this.state.brand &&
      this.state.brand !== prevState.brand // Check if the brand has changed
    ) {
      let selectedBrand = this.state.brands.filter(
        (brand) => brand.id === this.state.brand,
      );

      if (selectedBrand.length) {
        let platform = selectedBrand[0].platform;

        this.setState(() => ({
          availablePlatforms: platform,
        }));
      } else {
        this.setState(() => ({
          availablePlatforms: null,
        }));
      }
    }
  }

  componentDidMount() {
    this.changeInputEvent();
    this.getCompanies();
  }

  async getCompanies() {
    await window.axios
      .get("/company", {
        params: {
          perPage: 100,
        },
      })
      .then((res) => {
        this.setState({
          companies: res.data.docs,
        });
      });
  }

  async getBrands() {
    await window.axios
      .get("/brand", {
        params: {
          disabledBrands: true,
          company: this.state.company,
          page: 1,
          perPage: 800, //JiraId :- LDOTR-3
        },
      })
      .then((res) => {
        this.setState({
          brands: res.data.docs,
        });
      });
  }

  changeInputBoxValue(value, rowKey, domainKey) {
    let data = this.state.excelData;

    data[rowKey][domainKey] = value;

    this.setState({
      excelData: data,
    });
  }

  changeInputEvent() {
    const input = document.getElementById("input");
    input.addEventListener("change", () => {
      // every selected .xlsx: one is the data sheet, the others may be documents named in it
      const excelFiles = Array.from(input.files).filter(
        (file) =>
          file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      );
      let excelFile = excelFiles[0] || null;

      if (excelFile === null) {
        alert("No excel file found.");
        input.value = null;
        return;
      }

      let REASON_CODE_INDEX;

      // Replace with the actual index of the "Reason Code" column
      if (this.state.platform.toLocaleLowerCase() === "e-commerce") {
        REASON_CODE_INDEX = 8;
      } else if (this.state.platform.toLocaleLowerCase() === "social-media") {
        REASON_CODE_INDEX = 10;
      } else if (this.state.platform.toLocaleLowerCase() === "app-store") {
        REASON_CODE_INDEX = 12;
      } else if (this.state.platform.toLocaleLowerCase() === "website") {
        REASON_CODE_INDEX = 12;
      } else if (this.state.platform.toLocaleLowerCase() === "domain") {
        REASON_CODE_INDEX = 8;
      }

      this.setState({ filesUploading: true });

      this.chooseDataSheet(excelFiles)
        .then((chosen) => {
          if (!chosen) {
            input.value = null;
            this.setState({ filesUploading: false });
            return null;
          }
          excelFile = chosen.file;
          return chosen.rows || readXlsxFile(chosen.file);
        })
        .then((rows) => {
          if (!rows) return;

          // `rows` is an array of rows, each row being an array of cells
          let formData = [];
          const keyAt = this.sheetColumnKeys(rows[0] || []);
          rows.forEach((item, rowIndex) => {
            if (rowIndex > 0) {
              let formItem = {};

              item.forEach((itemValue, itemIndex) => {
                if (!keyAt(itemIndex)) return;

                if (itemIndex === REASON_CODE_INDEX) {
                  // Modify Reason Code field
                  const modifiedValue =
                    resolveReasonCode(itemValue?.toString() || "", {
                      companyId: this.state.company,
                    }) || "InvalidReasonCode";

                  formItem[keyAt(itemIndex)] =
                    modifiedValue;
                } else {
                  formItem[keyAt(itemIndex)] =
                    itemValue;
                }
              });

              Object.keys(formItem).forEach(() => {
                if (!formItem["priority"]) {
                  const reasonCode = formItem["reasonCode"];
                  formItem["priority"] =
                    reasonCodeBasedOnPriority?.[reasonCode] ||
                    reasonCodeToKeyPriority?.[reasonCode] ||
                    "";
                }
              });

              formData.push(formItem);
            }
          });
          // extra sheet columns can only be read once the company, and so its custom columns, is known
          const fixedCount = (this.state[this.state.selectedKey] || []).length;
          const unread = (rows[0] || []).filter((title, index) => title && index < 200 && !keyAt(index)).length;
          if (unread && !this.state.company) {
            this.props.alert.show(
              `${unread} extra column${unread === 1 ? "" : "s"} in the sheet ${unread === 1 ? "was" : "were"} not read because no company is selected. Select the company, then choose the files again.`,
              { type: "error", timeout: 12000 },
            );
          } else if (unread && (rows[0] || []).length > fixedCount) {
            this.props.alert.show(`${unread} column${unread === 1 ? "" : "s"} in the sheet ${unread === 1 ? "does" : "do"} not match a column of this company and ${unread === 1 ? "was" : "were"} skipped.`, {
              type: "error",
              timeout: 12000,
            });
          }

          // files named in a documents column are matched to their rows, the same way images are
          let documentPlan = { uploads: [], used: new Set(), problems: [] };
          try {
            documentPlan = planSheetDocuments(
              formData,
              documentsColumns(this.selectedCompany(), this.state.platform),
              Array.from(input.files),
              excelFile,
            );
          } catch (error) {
            documentPlan.problems.push("the documents named in the sheet could not be matched to the selected files");
          }
          this.sheetDocumentFiles = documentPlan.used;

          this.setState({ excelData: formData, files: input.files });
          this.handleFileUpload().then(() => this.attachSheetDocuments(documentPlan));
        })
        .catch(() => {
          alert("Failed to read excel file.");
          this.setState({ filesUploading: false });
        });
    });
  }

  // Custom columns belong to a company, and so do files uploaded for it. Rows already on screen lose both
  // when the company changes; the files are deleted so they are not left behind.
  changeCompany(company) {
    const uploaded = [];
    const rows = this.state.excelData.map((row) => {
      const kept = {};
      Object.entries(row).forEach(([key, value]) => {
        if (!isCustomColumnKey(key)) kept[key] = value;
        else if (Array.isArray(value)) uploaded.push(...value.filter((file) => file && file._id));
      });
      return kept;
    });
    const hadCustomValues = this.state.excelData.some((row) => Object.keys(row).some((key) => isCustomColumnKey(key) && row[key] !== "" && row[key] != null && !(Array.isArray(row[key]) && !row[key].length)));

    uploaded.forEach((file) => window.axios.delete(`/documents/${file._id}`).catch(() => {}));
    this.setState({ company, excelData: rows });

    if (hadCustomValues) {
      this.props.alert.show("The company changed, so its custom columns and uploaded documents were cleared from the rows. Choose the files again for the new company.", {
        type: "error",
        timeout: 12000,
      });
    }
  }

  // With several .xlsx files selected, the one whose header row matches this platform's columns and the
  // company's custom columns is the data sheet. If the headers do not settle it, the user is asked.
  // Resolves to { file, rows? }, or null when the user cancels.
  async chooseDataSheet(excelFiles) {
    if (excelFiles.length === 1) return { file: excelFiles[0] };

    // read every sheet's header and count the columns this platform and company expect
    const sheets = await Promise.all(
      excelFiles.map((file) =>
        readXlsxFile(file)
          .then((rows) => ({ file, rows }))
          .catch(() => ({ file, rows: [] })),
      ),
    );
    const titles = this.columnKeys().map((key) => COLUMN_LABELS[key] || (isCustomColumnKey(key) ? customColumnLabel(key) : key));
    const [best, next] = rankSheets(sheets, titles);

    // a clear winner is used as it is; the user is only asked when the headers do not settle it
    if (best.score >= 3 && best.score > next.score) {
      this.props.alert.show(`Using ${best.file.name} as the data sheet (${best.score} matching columns). Other Excel files are treated as documents.`);
      return best;
    }

    const result = await Swal.fire({
      title: "Which file is the data sheet?",
      text: "More than one Excel file was selected and their column titles do not show which one holds the rows. Pick it; the others are treated as documents.",
      input: "radio",
      inputOptions: Object.fromEntries(excelFiles.map((file, index) => [index, file.name])),
      inputValidator: (value) => (value === null || value === undefined || value === "" ? "Pick one file." : undefined),
      showCancelButton: true,
      confirmButtonText: "Use this file",
      allowOutsideClick: false,
    });

    return result.isConfirmed ? sheets.find((sheet) => sheet.file === excelFiles[Number(result.value)]) : null;
  }

  // Which column key a sheet column fills. Fixed columns go by position, as before. A custom column goes by
  // its title in the header row, so a sheet with or without an optional column (RID) still lines up;
  // without a matching title it takes the next position after the fixed columns.
  sheetColumnKeys(header) {
    const fixedKeys = this.state[this.state.selectedKey] || [];
    const title = (text) => String(text ?? "").replace(/\s+/g, " ").trim().toLowerCase();
    const byIndex = {};

    // a sheet column that is one of the fixed columns in its own place is never taken for a custom column,
    // even when a custom column was given the same name (e.g. "Brand")
    const isFixedColumn = (cell, index) => fixedKeys[index] && title(cell) === title(COLUMN_LABELS[fixedKeys[index]] || fixedKeys[index]);

    customColumnKeys(this.selectedCompany(), this.state.platform).forEach((key, position) => {
      const at = header.findIndex((cell, index) => title(cell) === title(customColumnLabel(key)) && !isFixedColumn(cell, index));
      byIndex[at >= 0 ? at : fixedKeys.length + position] = key;
    });

    return (index) => byIndex[index] || fixedKeys[index];
  }

  async attachSheetDocuments(plan) {
    if (plan.uploads.length) {
      this.setState({ filesUploading: true });
      const attached = await uploadSheetDocuments(plan, this.state.company, () => this.setState({ excelData: this.state.excelData }));
      this.setState({ filesUploading: false });
      if (attached) this.props.alert.show(`${attached} document${attached === 1 ? "" : "s"} attached from the selected files.`);
    }

    if (plan.problems.length) {
      const shown = plan.problems.slice(0, 5).join("; ");
      const more = plan.problems.length > 5 ? ` (+${plan.problems.length - 5} more)` : "";
      this.props.alert.show(`Documents not attached: ${shown}${more}`, { type: "error", timeout: 15000 });
    }
  }

  async handleFileUpload() {
    let files = this.state.files;
    let formData = new FormData();
    let regex = /newscrapper/;
    for (let i = 0; i < files.length; i++) {
      // a file that goes to a documents column is uploaded there, not with the images
      if (!regex.test(files[i]) && !this.sheetDocumentFiles?.has(files[i])) {
        formData.append("files", files[i]);
      }
    }

    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    this.setState({ filesUploading: true });

    await window.axios
      .post("/upload-images-to-s3", formData, options)
      .then((res) => {
        let uploadedFiles = {};

        res.data.Data.map((file, fileIndex) => {
          let uploadedImageName = file.uploadedImage.replace(/\s+/g, " ");
          uploadedFiles[uploadedImageName] = file;
        });

        this.setState({ uploadedFiles: uploadedFiles });

        let newPreparedExcelData = [];
        let matchedImages = [];
        this.state.excelData.map((data, dataIndex) => {
          let imageName = (data.image || "").replace(/\s+/g, " "); //Add "" if imageName is blank
          let dataImageInfo = this.state.uploadedFiles[imageName];
          data.imageUrl = null;
          data.s3BucketName = null;
          data.s3FullImagePath = null;

          if (dataImageInfo) {
            data.imageUrl = dataImageInfo.Location;
            data.s3BucketName = dataImageInfo.Bucket;
            data.s3FullImagePath = dataImageInfo.Key;
            matchedImages.push(dataImageInfo);
          } else {
            data.imageUrl = data.image || ""; //Add "" if imageName is blank
            data.s3BucketName = "newscrapper";
            data.s3FullImagePath = data.image?.split("/")[1] || ""; //Add "" if imageName is blank
          }

          newPreparedExcelData.push(data);
        });

        this.setState({
          excelData: newPreparedExcelData,
          filesUploading: false,
        });
      })
      .catch((error) => {
        this.setState({ filesUploading: false });
      });
  }

  async saveData() {
    const options = {
      headers: { "Content-Type": "application/json" },
    };

    this.setState(() => ({
      dataSaveError: {},
      urlDuplicates: 0,
      lidDuplicates: 0,
      imageCount: 0,
      invalidDomainCount: 0,
      statusCount: 0,
      whiteLabelDuplicates: {},
      urlDuplicatesErrors: {},
      lidDuplicatesErrors: {},
      imageDuplicatesErrors: {},
      brandDuplicatesErrors: {},
      statusDuplicatesErrors: {},
    }));

    let invalidReasonCode = false;

    // Modify the value of reasonCode property in each object of excelData array
    const modifiedExcelData = this.state.excelData.map((value) => {
      if (
        this.state.platform === "e-commerce" ||
        this.state.platform === "social-media" ||
        this.state.platform === "website" ||
        this.state.platform === "app-store" ||
        this.state.platform === "domain"
      ) {
        const reason = resolveReasonCode(value.reasonCode, {
          companyId: this.state.company,
        });
        if (reason) {
          value.reasonCode = reason;
        } else {
          // Display error message for invalid reason code
          invalidReasonCode = true;
        }
      } else {
        // do nothing
      }

      //If dateAdded column exists then take reporting date as dateAdded
      if (value.dateAdded !== undefined) {
        value.dateAdded = this.state.reportingDate;
      }

      if (
        this.state.platform === "e-commerce" &&
        value.categories &&
        value.categories != "0"
      ) {
        value.categories = value.categories.split(",");
      }
      return value;
    });

    // Store modifiedExcelData in state for potential Upload Unique functionality
    this.setState({ modifiedExcelData });

    if (invalidReasonCode) {
      this.props.alert.show("Invalid Reason Code", { type: "error" });
      return;
    }

    const filteredModifiedExcelData = modifiedExcelData.filter(
      (value) => value !== null,
    );

    try {
      await window.axios.post(
        "/save-bulk-data",
        {
          data: filteredModifiedExcelData.map(nestCustomColumns),
          company: this.state.company,
          brand: this.state.brand,
          reportingDate: this.state.reportingDate,

          platform: this.state.platform,
          duplicateLidCheck: this.state.duplicateLidCheck,
        },
        options,
      );
      this.setState({
        showDataSavedAlert: true,
        excelData: [],
        modifiedExcelData: [],
      });
      document.getElementById("input").value = null;
      this.props.alert.show("Data Saved Successfully");
    } catch (error) {
      const errors = error.response?.data?.errors || {};
      const {
        urlCount,
        lidCount,
        whiteLabelUrl,
        data,
        imageCount,
        invalidDomainCount,
        statusCount,
        message,
        whiteLabelDuplicates,
        urlDuplicates,
        lidDuplicates,
        imageDuplicates,
        brandDuplicates,
        statusDuplicates,
      } = errors;
      const message_ = toCapitalCase(error.response?.data?.message || "");

      this.setState({
        dataSaveError: errors,
        urlDuplicates: urlCount,
        lidDuplicates: lidCount,
        imageCount,
        invalidDomainCount,
        statusCount,
        whiteLabelUrlCount: whiteLabelUrl,
        whiteLabelDuplicates: whiteLabelDuplicates || {},
        urlDuplicatesErrors: urlDuplicates || {},
        lidDuplicatesErrors: lidDuplicates || {},
        imageDuplicatesErrors: imageDuplicates || {},
        brandDuplicatesErrors: brandDuplicates || {},
        statusDuplicatesErrors: statusDuplicates || {},
      });

      this.props.alert.show(message_, { type: "error" });
    }
  }

  async saveUniqueData() {
    if (
      !this.state.modifiedExcelData ||
      this.state.modifiedExcelData.length === 0
    ) {
      this.props.alert.show("No data available to upload", { type: "error" });
      return;
    }

    let urlField = "url";
    if (this.state.platform === "social-media") urlField = "link";
    if (this.state.platform === "domain") urlField = "domain";

    // Filter out entries that have errors and get unique data to upload
    const uniqueData = this.state.modifiedExcelData.filter((entry) => {
      // Check for URL/Link errors

      if (entry[urlField]) {
        if (
          this.state.urlDuplicatesErrors &&
          this.state.urlDuplicatesErrors[entry[urlField]]
        ) {
          return false;
        }
        if (
          this.state.whiteLabelDuplicates &&
          this.state.whiteLabelDuplicates[entry[urlField]]
        ) {
          return false;
        }
        if (
          this.state.imageDuplicatesErrors &&
          this.state.imageDuplicatesErrors[entry[urlField]]
        ) {
          return false;
        }
        if (
          this.state.brandDuplicatesErrors &&
          this.state.brandDuplicatesErrors[entry[urlField]]
        ) {
          return false;
        }
        if (
          this.state.statusDuplicatesErrors &&
          this.state.statusDuplicatesErrors[entry[urlField]]
        ) {
          return false;
        }
      }

      // Check for domain errors
      if (entry.domain) {
        if (
          this.state.urlDuplicatesErrors &&
          this.state.urlDuplicatesErrors[entry.domain]
        ) {
          return false;
        }
      }

      // Check for LID errors
      if (entry.lid) {
        if (
          this.state.lidDuplicatesErrors &&
          this.state.lidDuplicatesErrors[entry.lid]
        ) {
          return false;
        }
      }

      return true;
    });

    if (uniqueData.length === 0) {
      this.props.alert.show("No unique entries found to upload", {
        type: "error",
      });
      return;
    }

    const options = {
      headers: { "Content-Type": "application/json" },
    };

    try {
      await window.axios.post(
        "/save-bulk-data",
        {
          data: uniqueData.map(nestCustomColumns),
          company: this.state.company,
          brand: this.state.brand,
          reportingDate: this.state.reportingDate,
          platform: this.state.platform,
          duplicateLidCheck: this.state.duplicateLidCheck,
        },
        options,
      );

      // Filter out the successfully uploaded entries from excelData, keeping only errored ones
      const remainingExcelData = this.state.excelData.filter((entry) => {
        // Keep entries that have errors (opposite of uniqueData filter)
        if (entry[urlField]) {
          if (
            this.state.urlDuplicatesErrors &&
            this.state.urlDuplicatesErrors[entry[urlField]]
          ) {
            return true;
          }
          if (
            this.state.whiteLabelDuplicates &&
            this.state.whiteLabelDuplicates[entry[urlField]]
          ) {
            return true;
          }
          if (
            this.state.imageDuplicatesErrors &&
            this.state.imageDuplicatesErrors[entry[urlField]]
          ) {
            return true;
          }
          if (
            this.state.brandDuplicatesErrors &&
            this.state.brandDuplicatesErrors[entry[urlField]]
          ) {
            return true;
          }
          if (
            this.state.statusDuplicatesErrors &&
            this.state.statusDuplicatesErrors[entry[urlField]]
          ) {
            return true;
          }
        }

        if (entry.domain) {
          if (
            this.state.urlDuplicatesErrors &&
            this.state.urlDuplicatesErrors[entry.domain]
          ) {
            return true;
          }
        }

        if (entry.lid) {
          if (
            this.state.lidDuplicatesErrors &&
            this.state.lidDuplicatesErrors[entry.lid]
          ) {
            return true;
          }
        }

        return false; // Remove entries that don't have errors (they were uploaded)
      });

      // Update modifiedExcelData to match the remaining excelData
      const remainingModifiedData = this.state.modifiedExcelData.filter(
        (entry) => {
          // Keep entries that have errors (same logic as above)
          if (entry[urlField]) {
            if (
              this.state.urlDuplicatesErrors &&
              this.state.urlDuplicatesErrors[entry[urlField]]
            ) {
              return true;
            }
            if (
              this.state.whiteLabelDuplicates &&
              this.state.whiteLabelDuplicates[entry[urlField]]
            ) {
              return true;
            }
            if (
              this.state.imageDuplicatesErrors &&
              this.state.imageDuplicatesErrors[entry[urlField]]
            ) {
              return true;
            }
            if (
              this.state.brandDuplicatesErrors &&
              this.state.brandDuplicatesErrors[entry[urlField]]
            ) {
              return true;
            }
            if (
              this.state.statusDuplicatesErrors &&
              this.state.statusDuplicatesErrors[entry[urlField]]
            ) {
              return true;
            }
          }

          if (entry.domain) {
            if (
              this.state.urlDuplicatesErrors &&
              this.state.urlDuplicatesErrors[entry.domain]
            ) {
              return true;
            }
          }

          if (entry.lid) {
            if (
              this.state.lidDuplicatesErrors &&
              this.state.lidDuplicatesErrors[entry.lid]
            ) {
              return true;
            }
          }

          return false;
        },
      );

      this.setState({
        showDataSavedAlert: true,
        excelData: remainingExcelData,
        modifiedExcelData: remainingModifiedData,
      });

      this.props.alert.show(
        `${uniqueData.length} unique entries uploaded successfully! ${remainingExcelData.length} entries with errors remain for review.`,
      );
    } catch (error) {
      this.props.alert.show("Failed to upload unique data", { type: "error" });
    }
  }

  changePlatformSelectBox(e) {
    let selectedKeyValue = "domainKeys";

    let key = e.target.value;

    if (key === "website") {
      selectedKeyValue = "websiteKeys";
    }
    if (key === "social-media") {
      selectedKeyValue = "socialMediaKeys";
    }
    if (key === "e-commerce") {
      selectedKeyValue = "ecommerceKeys";
    }
    if (key === "app-store") {
      selectedKeyValue = "appStoreKeys";
    }

    this.setState({
      platform: e.target.value,
      excelData: [],
      modifiedExcelData: [],
      selectedKey: selectedKeyValue,
    });
  }
  renderUploadDataBtn() {
    const {
      filesUploading,
      urlDuplicates,
      lidDuplicates,
      imageCount,
      invalidDomainCount,
      statusCount,
    } = this.state;

    if (filesUploading) {
      return (
        <div className="col-md-2">
          <div className="form-group">
            <button className="mt-4 btn btn-ldotr" disabled>
              <i className="fa fa-spinner fa-spin" aria-hidden="true"></i>
              &nbsp;Loading…
            </button>
          </div>
        </div>
      );
    }

    // ✅ Collect all errors
    const errors = [];
    if (lidDuplicates > 0) errors.push(`${lidDuplicates} Duplicate LIDs`);
    if (urlDuplicates > 0) errors.push(`${urlDuplicates} Duplicate URLs`);
    if (imageCount > 0) errors.push(`${imageCount} Missing Images`);
    if (invalidDomainCount > 0)
      errors.push(`${invalidDomainCount} Invalid Brands`);
    if (statusCount > 0) errors.push(`${statusCount} Missing Status`);

    const whiteLabelCount = Object.keys(
      this.state.whiteLabelDuplicates || {},
    ).length;
    if (whiteLabelCount > 0) errors.push(`${whiteLabelCount} White Label URLs`);

    const hasErrors = errors.length > 0;

    return (
      <>
        <div className="col-md-2">
          <div className="form-group">
            <button
              onClick={() => this.saveData()}
              className="mt-4 btn btn-ldotr"
            >
              Upload Data
            </button>
          </div>
        </div>
        {hasErrors && (
          <div className="col-md-2">
            <div className="form-group">
              <button
                onClick={() => this.saveUniqueData()}
                className="mt-4 btn btn-success"
                style={{ marginLeft: "10px" }}
              >
                Upload Unique
              </button>
            </div>
          </div>
        )}
        {hasErrors && (
          <div className="col-md-2">
            <div className="mt-4 form-group" style={{ color: "red" }}>
              {errors.join(" • ")}
            </div>
          </div>
        )}
      </>
    );
  }

  domainComponent() {
    if (this.state.platform === "domain") {
      return (
        <div className="col">
          <div className="card card-small mb-4">
            <div className="card-body">
              {this.listHeaderComponent("Domain")}
              <div style={{ paddingTop: "20px" }} className="row">
                <div className="col-md-12">{this.renderVirtualTable()}</div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  fileUploadingMessage() {
    if (this.state.filesUploading) {
      return (
        <>
          <p>Wait until files are uploading.</p>
        </>
      );
    }
  }

  removeDataItem(rowKey) {
    let excelData = this.state.excelData;

    if (rowKey > -1) {
      excelData.splice(rowKey, 1); // 2nd parameter means remove one item only
    }

    this.setState(() => ({
      excelData,
    }));
  }

  hasUrlError(row, domainKey) {
    let urlField = "url";
    if (this.state.platform === "social-media") urlField = "link";
    if (this.state.platform === "domain") urlField = "domain";

    const domainField = "domain";
    const value = row[domainKey];

    if (domainKey === urlField || domainKey === "url" || domainKey === "link") {
      return (
        (this.state.whiteLabelDuplicates &&
          this.state.whiteLabelDuplicates[value]) ||
        (this.state.urlDuplicatesErrors &&
          this.state.urlDuplicatesErrors[value]) ||
        (this.state.dataSaveError?.duplicates &&
          this.state.dataSaveError.duplicates[value])
      );
    }

    if (domainKey === domainField || domainKey === "domain") {
      return (
        (this.state.urlDuplicatesErrors &&
          this.state.urlDuplicatesErrors[value]) ||
        (this.state.dataSaveError?.duplicates &&
          this.state.dataSaveError.duplicates[value])
      );
    }

    return false;
  }

  hasLidError(row, domainKey) {
    if (domainKey === "lid") {
      const lid = row["lid"];
      const hasError =
        (this.state.lidDuplicatesErrors &&
          this.state.lidDuplicatesErrors[lid]) ||
        (this.state.dataSaveError?.duplicates &&
          this.state.dataSaveError.duplicates[lid]);

      return hasError;
    }
    return false;
  }

  hasImageError(row, domainKey) {
    if (domainKey === "image") {
      let urlField = "url";
      if (this.state.platform === "social-media") urlField = "link";
      if (this.state.platform === "domain") urlField = "domain";

      const url = row[urlField];

      if (!url || !this.state.imageDuplicatesErrors) {
        return false;
      }

      const hasError = !!this.state.imageDuplicatesErrors[url];

      return hasError;
    }
    return false;
  }

  hasBrandError(row, domainKey) {
    if (domainKey === "brand") {
      let urlField = "url";
      if (this.state.platform === "social-media") urlField = "link";
      if (this.state.platform === "domain") urlField = "domain";

      const url = row[urlField];
      if (!url || !this.state.brandDuplicatesErrors) {
        return false;
      }

      // Check if current row's URL exists in brandDuplicates (any company/domain)
      return !!this.state.brandDuplicatesErrors[url];
    }
    return false;
  }

  hasStatusError(row, domainKey) {
    if (domainKey === "status") {
      let urlField = "url";
      if (this.state.platform === "social-media") urlField = "link";
      if (this.state.platform === "domain") urlField = "domain";

      const url = row[urlField];
      if (!url || !this.state.statusDuplicatesErrors) {
        return false;
      }

      // Check if current row's URL exists in statusDuplicates (any company/domain)
      return !!this.state.statusDuplicatesErrors[url];
    }
    return false;
  }

  hasColumnError(row, domainKey) {
    return (
      this.hasUrlError(row, domainKey) ||
      this.hasLidError(row, domainKey) ||
      this.hasImageError(row, domainKey) ||
      this.hasBrandError(row, domainKey) ||
      this.hasStatusError(row, domainKey)
    );
  }

  renderInfrigementComponentInput(domainKey, row, rowKey) {
    const documentsColumn = documentsColumnOf(this.selectedCompany(), this.state.platform, domainKey);
    if (documentsColumn) {
      return (
        <DocumentsCell
          company={this.state.company}
          files={row[domainKey]}
          maxFiles={documentsColumn.maxFiles}
          alert={this.props.alert}
          onBusy={(busy) => this.setState({ filesUploading: busy })}
          onChange={(files) => this.changeInputBoxValue(files, rowKey, domainKey)}
        />
      );
    }

    if (domainKey === "status" && this.state.platform !== "e-commerce") {
      return (
        <select
          value={row[domainKey]}
          className={
            this.hasColumnError(row, domainKey)
              ? "form-control duplicate-errors"
              : "form-control"
          }
          onChange={(e) =>
            this.changeInputBoxValue(e.target.value, rowKey, domainKey)
          }
        >
          {statusSelectOptions(
            { platform: this.state.platform, companyId: this.state.company },
            fetchInfrigementAllStatus,
          ).map((status, index) => (
            <option
              selected={row[domainKey] === status.code ? "selected" : ""}
              key={index}
              value={status.code}
            >
              {status.text}
            </option>
          ))}
        </select>
      );
    } else if (domainKey === "status" && this.state.platform === "e-commerce") {
      return (
        <select
          value={row[domainKey]}
          className={
            this.hasColumnError(row, domainKey)
              ? "form-control duplicate-errors"
              : "form-control"
          }
          onChange={(e) =>
            this.changeInputBoxValue(e.target.value, rowKey, domainKey)
          }
        >
          {statusSelectOptions(
            { platform: this.state.platform, companyId: this.state.company },
            fetchInfrigementEcommerceStatus,
          ).map((status, index) => (
            <option
              selected={row[domainKey] === status.code ? "selected" : ""}
              key={index}
              value={status.code}
            >
              {status.text}
            </option>
          ))}
        </select>
      );
    } else if (domainKey === "sn") {
      return (
        <>
          <a
            onClick={() => this.removeDataItem(rowKey)}
            className="text-danger"
            href="#"
          >
            <i className="fa fa-trash" aria-hidden="true"></i>
          </a>
          &nbsp;
          <span className="text-muted">{row[domainKey]}</span>
        </>
      );
    } else if (domainKey === "image") {
      return (
        <div className="vt-image-cell">
          {row.imageUrl && (
            <img className="vt-image-preview" src={row.imageUrl} alt="" />
          )}
          <input
            id={"input" + rowKey}
            type="file"
            name={domainKey}
            onChange={(e) => this.updateImageInputEvent(e.target.id, rowKey)}
            className={
              this.hasColumnError(row, domainKey)
                ? "form-control form-control-sm duplicate-errors"
                : "form-control form-control-sm"
            }
          />
        </div>
      );
    } else if (domainKey === "heroImage") {
      return (
        <>
          {row.heroImage && (
            <img className="vt-thumb-lg" src={row.heroImage} alt="hero" />
          )}
        </>
      );
    } else if (domainKey === "supportingImage") {
      const supportingUrls = (
        Array.isArray(row.supportingImage)
          ? row.supportingImage
          : (row.supportingImage || "").split(",")
      )
        .map((url) => String(url).trim())
        .filter((url) => url !== "" && url !== "0");
      if (supportingUrls.length === 0) {
        return null;
      }
      return (
        <div className="vt-thumb-group">
          {supportingUrls.map((url, imgIndex) => (
            <img
              key={imgIndex}
              className="vt-thumb-lg"
              src={url}
              alt="supporting"
            />
          ))}
        </div>
      );
    } ////    LDOTR-10 Start    ////
    else if (domainKey.toUpperCase() === "DATEADDED") {
      return (
        <input
          name={domainKey}
          onChange={(e) =>
            this.changeInputBoxValue(e.target.value, rowKey, domainKey)
          }
          value={this.state.reportingDate} //reporting date is DateAdded column
          className="form-control"
        />
      );
    } ////    LDOTR-10 End    ////
    else {
      if (domainKey === "lid") {
        return (
          <EditableCell
            key={`${rowKey}-${domainKey}-${row[domainKey] ?? ""}`}
            name={domainKey}
            onCommit={(value) =>
              this.changeInputBoxValue(value, rowKey, domainKey)
            }
            defaultValue={row[domainKey]}
            className={
              this.hasColumnError(row, domainKey)
                ? "form-control duplicate-errors"
                : "form-control"
            }
          />
        );
      } else if (
        [
          "PostDate",
          "LikesCount",
          "CommentsCount",
          "SharedCount",
          "Follwer/SubscriberCount",
          "LastPostDate",
          "LastPostComments",
          "LastPostLikes",
          "LastPostShare",
          "Creation/JoiningDate",
          "FollowingCount",
          "LastPostCount",
          "ViewCount",
          "PostCount/YouTube_VideoCount",
          "PostDuration_yt",
          "Telegram_LinkCount",
        ].includes(domainKey)
      ) {
        return this.renderNewColumnSocialMedia(row, rowKey, domainKey);
      } else {
        return (
          <EditableCell
            key={`${rowKey}-${domainKey}-${row[domainKey] ?? ""}`}
            name={domainKey}
            onCommit={(value) => {
              this.changeInputBoxValue(value, rowKey, domainKey);
              if (
                domainKey === "username" &&
                this.state.platform === "e-commerce"
              ) {
                if (this.state.dataSaveError?.whiteLabelUrl) {
                  delete this.state.dataSaveError.duplicates[row["url"]];
                }
              }
            }}
            defaultValue={row[domainKey]}
            className={
              this.hasColumnError(row, domainKey)
                ? "form-control duplicate-errors"
                : "form-control"
            }
          />
        );
      }
    }
  }

  renderNewColumnSocialMedia(row, rowKey, domainKey) {
    return (
      <EditableCell
        key={`${rowKey}-${domainKey}-${row[domainKey] ?? ""}`}
        name={domainKey}
        onCommit={(value) => this.changeInputBoxValue(value, rowKey, domainKey)}
        defaultValue={row[domainKey] || ""}
        className={
          this.hasColumnError(row, domainKey)
            ? "form-control duplicate-errors"
            : "form-control"
        }
      />
    );
  }

  updateImageInputEvent(id, rowKey) {
    const input = document.getElementById(id);

    if (!input) {
      return;
    }

    this.handleSingleImageUpload(input.files, rowKey);
  }

  async handleSingleImageUpload(files, rowKey) {
    let formData = new FormData();

    //Adding files to the formdata

    for (let i = 0; i < files.length; i++) {
      formData.append("files", files[i]);
    }

    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "true",
      },
    };

    await window.axios
      .post("/upload-images-to-s3", formData, options)
      .then((res) => {
        let upoadedFile = res.data.Data[0];
        let data = this.state.excelData;
        data[rowKey].image = upoadedFile.uploadedImage;
        data[rowKey].imageUrl = upoadedFile.Location;
        data[rowKey].s3BucketName = upoadedFile.Bucket;
        data[rowKey].s3FullImagePath = upoadedFile.Key;
        data[rowKey].updated = true;
        this.setState({ excelData: data });
      });
  }

  websiteComponent() {
    if (this.state.platform === "website") {
      return (
        <div className="col">
          <div className="card card-small mb-4">
            <div className="card-body">
              {this.listHeaderComponent("Website")}
              <div style={{ paddingTop: "20px" }} className="row">
                <div className="col-md-12">{this.renderVirtualTable()}</div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  socialMediaComponent() {
    if (this.state.platform === "social-media") {
      return (
        <div className="col">
          <div className="card card-small mb-4">
            <div className="card-body">
              {this.listHeaderComponent("Social Media")}

              <div style={{ paddingTop: "20px" }} className="row">
                <div className="col-md-12">{this.renderVirtualTable()}</div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  async addNewRecord() {
    let newRecord = {};

    this.columnKeys().map((index) => {
      newRecord[index] = "";
    });

    let currentData = this.state.excelData;
    newRecord["sn"] = currentData.length + 1;

    currentData.push(newRecord);

    this.setState(() => ({
      excelData: currentData,
    }));
  }

  ecommerceComponent() {
    if (this.state.platform === "e-commerce") {
      return (
        <div className="col">
          <div className="card card-small mb-4">
            <div className="card-body">
              {this.listHeaderComponent("E-COMMERCE")}
              <div style={{ paddingTop: "20px" }} className="row">
                <div className="col-md-12">{this.renderVirtualTable()}</div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  getErrorReason(row) {
    let urlField = "url";
    if (this.state.platform === "social-media") urlField = "link";
    if (this.state.platform === "domain") urlField = "domain";

    const errors = [];
    const currentUrl = row[urlField];
    const currentDomain = row.domain;
    const currentLid = row.lid;
    const currentImage = row.image;

    // Check for URL/Link errors with specific URL details
    if (currentUrl) {
      if (
        this.state.urlDuplicatesErrors &&
        this.state.urlDuplicatesErrors[currentUrl]
      ) {
        errors.push(`Duplicate URL: ${currentUrl}`);
      }
      if (
        this.state.whiteLabelDuplicates &&
        this.state.whiteLabelDuplicates[currentUrl]
      ) {
        errors.push(`White Label URL: ${currentUrl}`);
      }
      if (
        this.state.imageDuplicatesErrors &&
        this.state.imageDuplicatesErrors[currentUrl]
      ) {
        // Show image mapping details
        const imageInfo = currentImage
          ? `Image: "${currentImage}"`
          : "No Image";
        const imageUrl = row.imageUrl
          ? ` -> Mapped to: "${row.imageUrl}"`
          : " -> Not Mapped";
        errors.push(
          `Missing Image for URL: ${currentUrl} (${imageInfo}${imageUrl})`,
        );
      }
      if (
        this.state.brandDuplicatesErrors &&
        this.state.brandDuplicatesErrors[currentUrl]
      ) {
        errors.push(`Invalid Brand for URL: ${currentUrl}`);
      }
      if (
        this.state.statusDuplicatesErrors &&
        this.state.statusDuplicatesErrors[currentUrl]
      ) {
        errors.push(`Missing Status for URL: ${currentUrl}`);
      }
    }

    // Check for domain errors with specific domain details
    if (currentDomain) {
      if (
        this.state.urlDuplicatesErrors &&
        this.state.urlDuplicatesErrors[currentDomain]
      ) {
        errors.push(`Duplicate Domain: ${currentDomain}`);
      }
    }

    // Check for LID errors with specific LID details
    if (currentLid) {
      if (
        this.state.lidDuplicatesErrors &&
        this.state.lidDuplicatesErrors[currentLid]
      ) {
        errors.push(`Duplicate LID: ${currentLid}`);
      }
    }

    // Check for general image mapping issues
    if (currentImage && !row.imageUrl) {
      errors.push(
        `Image Not Found: "${currentImage}" could not be mapped to uploaded files`,
      );
    }

    return errors.length > 0 ? errors.join("; ") : "Unknown Error";
  }

  downloadErrorDataAsCSV() {
    if (!this.state.excelData || this.state.excelData.length === 0) {
      return;
    }

    const headers = [...this.columnKeys()];
    if (this.state.urlDuplicates > 0) {
      headers.push("URL/LINK Error");
    }
    if (this.state.lidDuplicates > 0) {
      headers.push("LID Error");
    }
    if (this.state.imageCount > 0) {
      headers.push("Image Error");
    }
    if (this.state.statusCount > 0) {
      headers.push("Status Error");
    }
    if (this.state.invalidDomainCount > 0) {
      headers.push("LINK/URL Error");
    }
    if (this.state.whiteLabelUrlCount > 0) {
      headers.push("White Label Error");
    }

    // Create CSV content
    let csvContent = headers.join(",") + "\n";

    // Map errors to the main excel data - dynamic field mapping based on platform
    let urlField = "url";
    if (this.state.platform === "social-media") urlField = "link";
    if (this.state.platform === "domain") urlField = "domain";

    const csvData = this.state.excelData.map((row) => {
      const newRow = { ...row };

      // Map each error type to the row using dynamic field mapping
      if (this.state.urlDuplicates > 0) {
        const urlDuplicates = this.state.urlDuplicatesErrors || {};
        const hasUrlError = row[urlField] && urlDuplicates[row[urlField]];
        newRow["URL/LINK Error"] = hasUrlError ? 1 : "";
      }

      if (this.state.lidDuplicates > 0) {
        const lidDuplicates = this.state.lidDuplicatesErrors || {};
        const lidField = "lid";
        const hasLidError = row[lidField] && lidDuplicates[row[lidField]];
        newRow["LID Error"] = hasLidError ? 1 : "";
      }

      if (this.state.imageCount > 0) {
        const imageDuplicates = this.state.imageDuplicatesErrors || {};
        const hasImageError = row[urlField] && imageDuplicates[row[urlField]];
        newRow["Image Error"] = hasImageError ? 1 : "";
      }

      if (this.state.statusCount > 0) {
        const statusDuplicates = this.state.statusDuplicatesErrors || {};
        const hasStatusError = row[urlField] && statusDuplicates[row[urlField]];
        newRow["Status Error"] = hasStatusError ? 1 : "";
      }

      if (this.state.invalidDomainCount > 0) {
        const brandDuplicates = this.state.brandDuplicatesErrors || {};
        const hasBrandError = row[urlField] && brandDuplicates[row[urlField]];
        newRow["LINK/URL Error"] = hasBrandError ? 1 : "";
      }

      if (this.state.whiteLabelUrlCount > 0) {
        const whiteLabelDuplicates = this.state.whiteLabelDuplicates || {};
        const hasWhiteLabelError =
          row[urlField] && whiteLabelDuplicates[row[urlField]];
        newRow["White Label Error"] = hasWhiteLabelError ? 1 : "";
      }

      return newRow;
    });

    csvData.forEach((row) => {
      const rowData = headers.map((header) => {
        const value = row[header] || "";
        // Escape commas and quotes in CSV
        if (
          typeof value === "string" &&
          (value.includes(",") || value.includes('"'))
        ) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      });

      csvContent += rowData.join(",") + "\n";
    });

    // Create and download file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `error_data_${this.state.platform || "unknown"}_${new Date()
        .toISOString()
        .slice(0, 10)}.csv`,
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  // the platform's fixed columns, then the selected company's custom columns for that platform
  selectedCompany() {
    return this.state.companies.find((item) => (item.id || item._id) === this.state.company);
  }

  columnKeys() {
    const company = this.selectedCompany();
    return [...(this.state[this.state.selectedKey] || []), ...customColumnKeys(company, this.state.platform)];
  }

  renderVirtualTable() {
    const keys = this.columnKeys();
    const columns = keys.map((key) => ({
      key,
      label: COLUMN_LABELS[key] || (isCustomColumnKey(key) ? customColumnLabel(key) : key),
      width: COLUMN_WIDTHS[key] || 160,
    }));

    return (
      <VirtualTable
        columns={columns}
        rows={this.state.excelData}
        renderCell={(row, rowIndex, key) =>
          this.renderInfrigementComponentInput(key, row, rowIndex)
        }
        cellClassName={(row, key) =>
          this.hasColumnError(row, key) ? "duplicate-error" : ""
        }
      />
    );
  }

  listHeaderComponent(heading) {
    return (
      <>
        <h5 style={{ display: "inline" }} className="card-title">
          {heading}
          <div className="col-14 text-right mb-0 add-single-record-btn-wrapper  ">
            {this.state.excelData && this.state.excelData.length > 0 && (
              <button
                type="button"
                style={{
                  background: "none",
                  border: "none",
                  padding: "5px 10px",
                  marginRight: "10px",
                  cursor: "pointer",
                }}
                onClick={() => this.downloadErrorDataAsCSV()}
                title="Download error data as CSV"
              >
                <i className="fa fa-download" aria-hidden="true"></i>
              </button>
            )}
            <button
              type="button"
              className="btn btn-primary add-single-record-btn"
              onClick={() => this.addNewRecord()}
            >
              Add a record
            </button>
          </div>
        </h5>
      </>
    );
  }

  appStoreComponent() {
    if (this.state.platform === "app-store") {
      return (
        <div className="col">
          <div className="card card-small mb-4">
            <div className="card-body">
              {this.listHeaderComponent("APP STORE")}

              <div style={{ paddingTop: "20px" }} className="row">
                <div className="col-md-12">{this.renderVirtualTable()}</div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  handleChange = (selectedOption) => {
    const selectedBrand = this.state.brands.find(
      (brand) => brand.id === selectedOption.value,
    );

    this.setState({
      brand: selectedOption.value,
      brandId: selectedBrand ? selectedBrand.id : null,
    });
  };

  renderHtml() {
    if (!this.state.authorised) {
      return <UnauthorisedPage />;
    }

    const options = this.state.brands.map((brand) => ({
      value: brand.id,
      label: brand.brandName,
    }));
    options.unshift({ value: undefined, label: "Select from Brand" });

    return (
      <div className="row">
        {this.props?.login?.user?.role === "Admin" ? (
          <AdminSideNav />
        ) : (
          <AnalystSideNav />
        )}

        <main
          id="data-upload-screen"
          className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3"
        >
          <TopNav />

          <div className="main-content-container container-fluid px-4">
            <div className="page-header row no-gutters py-4">
              <div className="col-12">
                <div className="row">
                  <div className="col-12 col-sm-4 text-sm-left mb-0">
                    <span className="text-uppercase page-subtitle">
                      Upload Data
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="card card-small mb-4">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <span className="text-muted d-block mb-2">
                              Company
                            </span>
                            <select
                              onChange={(e) => this.changeCompany(e.target.value)}
                              className="form-control"
                            >
                              <option value="">Select from dropdown</option>
                              {this.state.companies.map(
                                (company, companyIndex) => (
                                  <option key={companyIndex} value={company.id}>
                                    {company.name}
                                  </option>
                                ),
                              )}
                            </select>
                            {this.state.dataSaveError?.company && (
                              <span className="text-danger">
                                {this.state.dataSaveError?.company}
                              </span>
                            )}
                          </div>
                        </div>
                        {/* <div className="col-md-3">
                          <div className="form-group">
                            <span className="text-muted d-block mb-2">
                              Brand
                            </span>
                            <select
                              onChange={(e) =>
                                this.setState({ brand: e.target.value })
                              }
                              className="form-control"
                            >
                              <option value="">Select from dropdown</option>
                              {this.state.brands.map((brand, brandKey) => (
                                <option key={brandKey} value={brand.id}>
                                  {brand.brandName}
                                </option>
                              ))}
                            </select>
                            {this.state.dataSaveError?.brand && (
                              <span className="text-danger">
                                {this.state.dataSaveError?.brand}
                              </span>
                            )}
                          </div>
                        </div> */}
                        <div className="col-md-3">
                          <div className="form-group">
                            <span className="text-muted d-block mb-2">
                              Brand
                            </span>
                            {/* <select
                              onChange={(e) =>
                                this.setState({ brand: e.target.value })
                              }
                              className="form-control"
                            >
                              <option value="">Select from dropdown</option>
                              {this.state.brands.map((brand, brandKey) => (
                                <option key={brandKey} value={brand.id}>
                                  {brand.brandName}
                                </option>
                              ))}
                            </select> */}
                            <Select
                              options={options}
                              onChange={this.handleChange}
                              defaultValue={{
                                value: undefined,
                                label: "Select from Brand",
                              }}
                            />

                            {this.state.dataSaveError?.brand && (
                              <span className="text-danger">
                                {this.state.dataSaveError?.brand}
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <span className="text-muted d-block mb-2">
                              Platform
                            </span>
                            {/* <select
                              onChange={(e) => this.changePlatformSelectBox(e)}
                              className="form-control"
                            >
                              <option value="">Select from dropdown</option>
                              <option value="domain">Domain</option>
                              <option value="website">Website</option>
                              <option value="social-media">Social Media</option>
                              <option value="e-commerce">E-commerce</option>
                              <option value="app-store">App Store</option>
                            </select> */}
                            <select
                              value={this.state.platform}
                              onChange={(e) => this.changePlatformSelectBox(e)}
                              className="form-control"
                            >
                              <option value="">Select from dropdown</option>
                              {((this.state.availablePlatforms &&
                                this.state.availablePlatforms.domain) ||
                                !this.state.availablePlatforms) && (
                                <option value="domain">Domain</option>
                              )}
                              {((this.state.availablePlatforms &&
                                this.state.availablePlatforms.website) ||
                                !this.state.availablePlatforms) && (
                                <option value="website">Website</option>
                              )}
                              {((this.state.availablePlatforms &&
                                this.state.availablePlatforms.socialMedia) ||
                                !this.state.availablePlatforms) && (
                                <option value="social-media">
                                  Social Media
                                </option>
                              )}
                              {((this.state.availablePlatforms &&
                                this.state.availablePlatforms.eCommerce) ||
                                !this.state.availablePlatforms) && (
                                <option value="e-commerce">E-commerce</option>
                              )}
                              {((this.state.availablePlatforms &&
                                this.state.availablePlatforms.appStore) ||
                                !this.state.availablePlatforms) && (
                                <option value="app-store">App Store</option>
                              )}
                            </select>
                            {this.state.dataSaveError?.platform && (
                              <span className="text-danger">
                                {this.state.dataSaveError?.platform}
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="col-md-3">
                          <div className="form-group">
                            <span className="text-muted d-block mb-2">
                              Reporting Date
                            </span>
                            <input
                              type="date"
                              id="start"
                              name="trip-start"
                              value={this.state.reportingDate}
                              onChange={(e) =>
                                this.setState({ reportingDate: e.target.value })
                              }
                              className="form-control"
                              min="2018-01-01"
                            />
                          </div>
                          {this.state.dataSaveError?.reportingDate && (
                            <span className="text-danger">
                              {this.state.dataSaveError?.reportingDate}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-2">
                          <div className="form-group">
                            <label
                              htmlFor="input"
                              className="form-label text-muted mb-2"
                            >
                              Upload Files
                            </label>
                            <input
                              id="input"
                              name="files"
                              multiple
                              type="file"
                              className="form-control"
                            />
                          </div>

                          {/* {this.state.dataSaveError?.data && (
                            <div className="text-danger mt-1 small">
                              {this.state.dataSaveError.data}
                            </div>
                          )} */}
                        </div>
                        <div className="col-md-2">
                          <div className="form-check form-switch mt-4">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="duplicateLidSwitch"
                              checked={this.state.duplicateLidCheck}
                              onChange={() =>
                                this.setState({
                                  duplicateLidCheck:
                                    !this.state.duplicateLidCheck,
                                })
                              }
                            />
                            <label
                              className="form-check-label ms-2"
                              htmlFor="duplicateLidSwitch"
                            >
                              Duplicate LID Check
                            </label>
                          </div>
                        </div>

                        {this.renderUploadDataBtn()}
                        <div className="col-md-2">
                          <div
                            style={{
                              margin: 0,
                              padding: 0,
                              marginTop: 25,
                              color: "#c17900",
                            }}
                            className="form-group"
                          >
                            {this.fileUploadingMessage()}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Domain Upload Screen */}
            {this.domainComponent()}
            {/* Website upload screen */}
            {this.websiteComponent()}
            {/* Social Media Screen */}
            {this.socialMediaComponent()}
            {/* E-COMMERCE */}
            {this.ecommerceComponent()}
            {/* APP STORE */}
            {this.appStoreComponent()}
          </div>
          {/* data saved sweet alert */}
          <Footer />
        </main>
      </div>
    );
  }

  render() {
    return <>{this.renderHtml()}</>;
  }
}

const mapStateToProps = (state) => ({
  login: state.login,
  response: state.response,
});

export default withAlert()(
  connect(mapStateToProps)(authorizeAnalystOrAdmin(requireAuth(DataUpload))),
);
